import { render, staticRenderFns } from "./MenuItemShow.vue?vue&type=template&id=79d7f34e&scoped=true&"
import script from "./MenuItemShow.vue?vue&type=script&lang=js&"
export * from "./MenuItemShow.vue?vue&type=script&lang=js&"
import style0 from "./MenuItemShow.vue?vue&type=style&index=0&id=79d7f34e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d7f34e",
  null
  
)

export default component.exports